export const SUPPORT_WHATSAPP_NUMBER = '554792157013';
